import styled from '@emotion/styled';

export const FullScreenLoadingStyled = {
    Container: styled.div<any>`
      display: flex;
      flex: 1;
      justify-content: center;
      align-items: center;
      height: 100vh; 
    `,
  };